import {
  PARKING_LOADING,
  PARKING_ERROR,
  PARKING_LIST
} from "actions/scooter/parking/constants";

const initialState = {
  loading: false,
  errors: [],

  list: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case PARKING_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case PARKING_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case PARKING_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload.content,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/scooter/scooterParkingReducer.js